// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".max-w-8[data-v-dea72142]{max-width:8ch}.max-w-15[data-v-dea72142]{max-width:15ch}.max-w-25[data-v-dea72142]{max-width:25ch}.max-w-28[data-v-dea72142]{max-width:28ch}", ""]);
// Exports
module.exports = exports;
